import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import * as classNames from 'classnames';
import { IAppStore } from 'stores/AllStores';
import { LeadGroupModalStatus, ILeadGroup } from 'common/interfaces/provider';

// Styles
const s = require('./GroupList.css');
const arrow = require('assets/blue arrow.svg');
const plus = require('assets/plus icon.svg');

// Props
interface IGroupListProps {
  store?: IAppStore;
}

// Component
@inject('store')
@observer
export class GroupList extends React.Component<IGroupListProps, {}> {
  constructor(props: IGroupListProps) {
    super(props);
  }

  public render() {
    const { leadGroup } = this.props.store;

    return (
      <div className={s.groupListContainer}>
        {(leadGroup.groupSearchedResults.length > 0 && (
          <div className={s.groupList}>
            {this.renderCreateGroupItem()}
            {leadGroup.groupSearchedResults.map((groupSearchResult, index) => (
              <div className={s.groupListItem} key={groupSearchResult.id}>
                <button
                  className={s.groupListButton}
                  onClick={this.handleGroupClick(groupSearchResult)}
                >
                  <p className={s.groupName}>{groupSearchResult.name}</p>
                  <img className={s.icon} src={arrow} alt="" />
                </button>
              </div>
            ))}
          </div>
        )) || (
          <div className={classNames(s.groupList, s.empty)}>
            {this.renderCreateGroupItem(
              leadGroup.leadGroups.length > 0
                ? 'No groups have been found, create new group'
                : 'Create new group'
            )}
          </div>
        )}
      </div>
    );
  }

  private renderCreateGroupItem = (label: string = 'Create new group') => {
    return (
      <div className={s.groupListItem}>
        <button
          className={classNames(s.groupListButton, s.groupListCreateButton)}
          onClick={this.handleCreateGroupClick}
        >
          <strong className={s.groupName}>{label}</strong>
          <img className={s.icon} src={plus} alt="" />
        </button>
      </div>
    );
  };

  @action private handleGroupClick = (groupSearchResult: ILeadGroup) => (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    this.props.store.leadGroup.openedGroup = groupSearchResult;
    this.props.store.leadGroup.modalStatus =
      LeadGroupModalStatus.OpenedOnSpecificGroup;
  };

  @action private handleCreateGroupClick = (
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    this.props.store.leadGroup.modalStatus =
      LeadGroupModalStatus.OpenedOnCreateGroup;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/BusinessGroup/GroupList.tsx